var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPanaceaLogo = function SvgPanaceaLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 32.698811,
    x2: 86,
    y2: 139.70163,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 53.75,
    y1: 32.698811,
    x2: 53.75,
    y2: 139.70163,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 59.125,
    y1: 32.698811,
    x2: 59.125,
    y2: 139.70163,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 139.75,
    y1: 32.698811,
    x2: 139.75,
    y2: 139.70163,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 126.3125,
    y1: 32.698811,
    x2: 126.3125,
    y2: 139.70163,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 26.875,
    y1: 95.40625,
    x2: 26.875,
    y2: 124.296883,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.862745%,97.647059%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8995804"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 40.625 39.84375 L 10.15625 39.84375 C 5.847656 39.84375 2.34375 36.339844 2.34375 32.03125 C 2.34375 28.089844 5.273438 24.824219 9.070312 24.292969 C 8.753906 23.257812 8.59375 22.1875 8.59375 21.09375 C 8.59375 15.0625 13.5 10.15625 19.53125 10.15625 C 24.085938 10.15625 28.121094 12.980469 29.726562 17.160156 C 31.066406 16.164062 32.675781 15.625 34.375 15.625 C 38.683594 15.625 42.1875 19.128906 42.1875 23.4375 C 42.1875 24.273438 42.054688 25.09375 41.792969 25.878906 C 45.113281 26.441406 47.65625 29.34375 47.65625 32.8125 C 47.65625 36.691406 44.503906 39.84375 40.625 39.84375 Z M 10.15625 25.78125 C 6.710938 25.78125 3.90625 28.585938 3.90625 32.03125 C 3.90625 35.476562 6.710938 38.28125 10.15625 38.28125 L 40.625 38.28125 C 43.640625 38.28125 46.09375 35.828125 46.09375 32.8125 C 46.09375 29.816406 43.65625 27.363281 40.660156 27.347656 L 39.40625 27.335938 L 39.964844 26.214844 C 40.402344 25.339844 40.625 24.402344 40.625 23.4375 C 40.625 19.992188 37.820312 17.1875 34.375 17.1875 C 32.679688 17.1875 31.09375 17.855469 29.90625 19.074219 L 28.941406 20.0625 L 28.589844 18.722656 C 27.515625 14.601562 23.789062 11.71875 19.53125 11.71875 C 14.363281 11.71875 10.15625 15.925781 10.15625 21.09375 C 10.15625 22.339844 10.398438 23.550781 10.878906 24.699219 L 11.328125 25.78125 Z M 10.15625 25.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 13.28125 21.09375 L 11.71875 21.09375 C 11.71875 16.785156 15.222656 13.28125 19.53125 13.28125 L 19.53125 14.84375 C 16.085938 14.84375 13.28125 17.648438 13.28125 21.09375 Z M 13.28125 21.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 16.40625 21.09375 L 14.84375 21.09375 C 14.84375 18.507812 16.945312 16.40625 19.53125 16.40625 L 19.53125 17.96875 C 17.808594 17.96875 16.40625 19.371094 16.40625 21.09375 Z M 16.40625 21.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 40.625 36.71875 C 38.472656 36.71875 36.71875 34.964844 36.71875 32.8125 C 36.71875 30.660156 38.472656 28.90625 40.625 28.90625 C 42.777344 28.90625 44.53125 30.660156 44.53125 32.8125 C 44.53125 34.964844 42.777344 36.71875 40.625 36.71875 Z M 40.625 30.46875 C 39.332031 30.46875 38.28125 31.519531 38.28125 32.8125 C 38.28125 34.105469 39.332031 35.15625 40.625 35.15625 C 41.917969 35.15625 42.96875 34.105469 42.96875 32.8125 C 42.96875 31.519531 41.917969 30.46875 40.625 30.46875 Z M 40.625 30.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 39.0625 23.4375 L 37.5 23.4375 C 37.5 21.714844 36.097656 20.3125 34.375 20.3125 L 34.375 18.75 C 36.960938 18.75 39.0625 20.851562 39.0625 23.4375 Z M 39.0625 23.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 10.15625 36.71875 C 7.566406 36.71875 5.46875 34.621094 5.46875 32.03125 C 5.46875 29.441406 7.566406 27.34375 10.15625 27.34375 Z M 10.15625 36.71875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPanaceaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/panacea-logo.8789a31d.svg";
export { ForwardRef as ReactComponent };